import { PageContext } from "@redotech/redo-model/agents/page-context";
import { createContext, useMemo, useState } from "react";

export interface GlobalAgentContextType {
  pageContext?: PageContext;
  setPageContext: (context: PageContext | undefined) => void;
}

export const GlobalAgentContext = createContext<GlobalAgentContextType>({
  pageContext: undefined,
  setPageContext: () => {},
});

export interface GlobalAgentProviderProps {
  children: React.ReactNode;
}

export function GlobalAgentProvider({ children }: GlobalAgentProviderProps) {
  const [pageContext, setPageContext] = useState<PageContext | undefined>(
    undefined,
  );

  const contextValue = useMemo(
    () => ({
      pageContext,
      setPageContext,
    }),
    [pageContext],
  );

  return (
    <GlobalAgentContext.Provider value={contextValue}>
      {children}
    </GlobalAgentContext.Provider>
  );
}
